/* 
Author:Lamiaa Moustafa
Desc: Reusable Text component
*/

import React from "react";
import styled from "styled-components";
import useMediaQuery from "../../Styles/useMediaQuery.jsx";


const Text1st2911 = (props) => {
  const { text, customStyle } = props.data;
const isDesktop = useMediaQuery("(min-width: 575px)");
  return (
    <>
      <Paragraph style={{...customStyle,marginLeft:isDesktop ? "40px" : "15px"}}>{text}</Paragraph>
    </>
  );
};

 export default Text1st2911;

 const Paragraph = styled.p`
 font-size: 18px;
 color: var(--white);
`;


